import { Text } from '@rtkwlf/c3-core-react';

import styles from './spidr-details.module.css';

export const SpidrDetailsList: React.FC<{ value: string[] | undefined }> = ({
  value,
}) => {
  if (!value || value.length === 0) {
    return <Text>-</Text>;
  }

  if (value.length === 1) {
    return <Text>{value[0]}</Text>;
  }

  return (
    <ul className={styles['spidr-details-list']}>
      {value.map((v) => (
        <li key={v}>
          <Text>{v}</Text>
        </li>
      ))}
    </ul>
  );
};
